import React, { useState, useEffect, useMemo } from 'react';
import { Card, CardBody, Spinner } from 'reactstrap';
import { MdOutlinePeopleAlt } from "react-icons/md";
import RecentEntryCard from './RecentEntryCard';
import { CompactPagination } from '../../../../Common/Pagination';
import "./Recententry.css";
import Entry_Camera_Monitor from '../Entry_Camera_Monitor';
import { Defaultpageifl } from '../../../../../api/defaultpageifl';

function RecentEntryDetections({  filters, handleImageClick }) {
  const [livealertsdata, setLivealertsdata] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [recentEntryLoader, setRecentEntryLoader] = useState(false);
  const itemsPerPage = 50; // Number of items per page
  
  const getlivealertsdata = async (page = 0) => {
    setRecentEntryLoader(true);
    
    const userData = JSON.parse(localStorage.getItem('userData'));

    const payload = {
      client_id: userData?.client?.id,
      factory_id: userData?.factory?.id,
      limit: itemsPerPage,
      offset: page, // Page number starting from 0
      camera_id: "",
      employee_id: "",
      filters: {
        date: filters?.date,
        week: filters?.week,
        month: filters?.month,
        starting: "",
        ending: "",
      },
    };

    try {
      const res = await Defaultpageifl.getLiveAlertss(payload);

      if (res.status === 200) {
        const allData = res.data.data.logs || [];
        const totalCount = res.data.data.total_alerts || allData.length;
        const filtered = allData.filter((e) => e.camera_position_no == 'Gate In');
        
        setLivealertsdata(filtered);
        setTotalItems(totalCount);
        console.log("Filtered entry data:", filtered);
      }
    } catch (error) {
      console.error("Error fetching entry detections:", error);
    } finally {
      setRecentEntryLoader(false);
    }
  };

  // Calculate pagination data
  const paginationData = useMemo(() => {
    const startIndex = currentPage * itemsPerPage;
    const endIndex = Math.min(startIndex + itemsPerPage, totalItems);
    
    return {
      startIndex,
      endIndex,
      totalItems,
      currentData: livealertsdata,
      hasNextPage: endIndex < totalItems,
      hasPrevPage: currentPage > 0
    };
  }, [currentPage, itemsPerPage, totalItems, livealertsdata]);

  // Handle page change
  const handlePageChange = (page) => {
    setCurrentPage(page);
    getlivealertsdata(page);
  };

  // Reset to first page when filters change
  useEffect(() => {
    setCurrentPage(0);
    getlivealertsdata(0);
  }, [filters]);

  return (
    <Card>
      <CardBody>
        {/* Heading */}
        <div className="d-flex align-items-center mb-3 gap-2">
          <MdOutlinePeopleAlt style={{ fontSize: "20px" }} />
          <h2 className='py-3' style={{ fontSize: "18px", fontWeight: "600", color: "#1D67AA", margin: "0px" }}>
            Recent Entry Detections
          </h2>
        </div>

        {/* Activity count */}
        {!recentEntryLoader && Array.isArray(livealertsdata) && livealertsdata.length > 0 && (
          <div className="d-flex justify-content-between align-items-center mb-3">
            <small style={{ color: "#6B7280", fontSize: "12px" }}>
              Showing {paginationData.startIndex + 1}-{paginationData.endIndex} of {paginationData.totalItems} entries
            </small>
          </div>
        )}

        {/* Loader */}
        {recentEntryLoader ? (
          <div className="d-flex justify-content-center align-items-center" style={{ height: "200px" }}>
            <Spinner style={{ width: '2.5rem', height: '2.5rem', color: '#1D67AA' }} />
          </div>
        ) : livealertsdata?.length > 0 ? (
          <>
            {livealertsdata?.map((item, index) => (
              <RecentEntryCard
                key={`${currentPage}-${index}`}
                backgroundcolor={item.employee_id === "IFL_unknown" ? "#EF4444" : "#1D67AA"}
                color="#FAFAFA"
                recbadge={item.employee_id === "IFL_unknown" ? "Unknown" : "Recognized"}
                Time={item.detection_datetime?.split(' ')[1] || "Just now"}
                post={item.employee_designation || (item.employee_id === "IFL_unknown" ? "Unidentified" : "Employee")}
                employName={item.employee_name || "Unknown Person"}
                // confidence={item.confidence ? `${item.confidence}% confidence` : "N/A"}
                image={item.face_image_url}
                handleImageClick={handleImageClick}
              />
            ))}

            {/* Compact Pagination */}
            {!recentEntryLoader && totalItems > itemsPerPage && (
              <CompactPagination
                totalItems={totalItems}
                itemsPerPage={itemsPerPage}
                currentPage={currentPage}
                onPageChange={handlePageChange}
              />
            )}
          </>
        ) : (
          <p style={{ color: "#9CA3AF", fontSize: "14px" }}>No recent entry data available.</p>
        )}
      </CardBody>
    </Card>
  );
}

export default RecentEntryDetections;
